module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "toc2"
  }, [_c('span', [_c('b', [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/cover"
    }
  }, [_vm._v("WIDE IS THE GATE")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part01"
    }
  }, [_vm._v("Book One: Into the Lion’s Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001"
    }
  }, [_vm._v("1 Dust to Dust")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter001#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002"
    }
  }, [_vm._v("2 Indoctus Pauperiem Pati")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter002#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003"
    }
  }, [_vm._v("3 A Young Man Married")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter003#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004"
    }
  }, [_vm._v("4 When Duty Whispers")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter004#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part02"
    }
  }, [_vm._v("Book Two: Some Hidden Thunder")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005"
    }
  }, [_vm._v("5 Des Todes Eigen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter005#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006"
    }
  }, [_vm._v("6 On Top of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch13"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter006#ch14"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007"
    }
  }, [_vm._v("7 Spirits of Just Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter007#ch13"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008"
    }
  }, [_vm._v("8 The Dusky Clouds Ascending")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter008#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009"
    }
  }, [_vm._v("9 Shape of Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch11"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter009#ch12"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/part03"
    }
  }, [_vm._v("Book Three: The Worst Is Yet to Come")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010"
    }
  }, [_vm._v("10 The Head That Wears a Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch1"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch2"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch3"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch4"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch5"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch6"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch7"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch8"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch9"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "href": "#/Book1/xhtml/chapter010#ch10"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Farewell to Every Fear")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter011#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Perilous Edge of Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter012#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 A Brand from Heaven")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter013#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: Truth Forever on the Scaffold")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 When We Two Parted")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter014#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Need a Body Cry?")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter015#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Survival of the Fittest")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter016#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 A Fruitless Crown")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter017#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: A Tide in the Affairs of Men")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Fears of the Brave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter018#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Where Men Decay")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter019#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Disastrous Twilight")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter020#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Hazard of the Die")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter021#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: Through Slaughter to a Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Put Money in Thy Purse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter022#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Sic Transit Gloria")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter023#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 True Faith of an Armorer")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter024#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 O Freude, Habe Acht!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter025#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: A Hangman’s Whip")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Perils Did Abound")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter026#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 The Way to Dusty Death")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter027#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 So Money Comes Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter028#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Eight: The World Turned Pale")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Ignorant Armies")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter029#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 My Life Upon a Cast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter030#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Put It to the Touch")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter031#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 And Win or Lose it All")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book1/xhtml/chapter032#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("PRESIDENTIAL AGENT")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One: Seats of the Mighty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 Sweet Aspect of Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter001#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Wise as Serpents")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter002#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Trust in Princes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter003#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Plus Triste Que Les Nuits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter004#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: Wrong Forever on the Throne")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 Forward Into Battle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter005#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Blondel Song")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter006#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Spain’s Chivalry Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter007#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 This Yellow Slave")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter008#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: Most Disastrous Chances")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 His Honor Rooted in Dishonor")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter009#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 Falsely True")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter010#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 Time by the Forelock")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter011#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 Observe the Opportunity")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter012#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 My Life on Any Chance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter013#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: In the Midst of Wolves")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The Jingling of the Guinea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter014#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 To Have a Giant’s Strength")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter015#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Fuming Vanities")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter016#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Dangerous Majesty")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter017#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: Extravagant and Erring Spirit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Après Nous Le Déluge")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter018#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Vaulting Ambition")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter019#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 Mohammed’s Mountain")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter020#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Der Führer Hat Immer Recht")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter021#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Foul Deeds Will Rise")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter022#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: A Full Hot Horse")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Les Beaux Yeux De Ma Casette")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter023#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 God’s Footstool")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter024#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 Slings and Arrows")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter025#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Pleasure Never Is at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter026#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: The Things That Are Caesar’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 Fever of the World")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter027#ch15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Stars in their Courses")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter028#ch14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 The Hurt That Honor Feels")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter029#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Hell’s Foundations Tremble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter030#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Courage Mounteth with Occasion")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book2/xhtml/chapter031#ch13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/cover",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("DRAGON HARVEST")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part01",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book One: Regardless of their Doom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1 The Little Victims Play")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter001#ch1-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2 Cherry Ripe, Ripe, Ripe!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter002#ch2-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3 Gold Will Be Master")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter003#ch3-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4 Portents of Impending Doom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter004#ch4-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part02",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Two: Who Sups with the Devil")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5 The Pitcher to the Well")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter005#ch5-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6 Fighting the Devil with Fire")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter006#ch6-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7 Heute Gehört Uns Deutschland")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter007#ch7-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8 Face of Danger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter008#ch8-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9 Time Gallops Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter009#ch9-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part03",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Three: Let Joy Be Unconfined")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10 When Fortune Favors")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter010#ch10-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11 The Trail of the Serpent")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter011#ch11-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12 T’Other Dear Charmer Away")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter012#ch12-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13 Where Duty Calls Me")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter013#ch13-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Four: The Brazen Throat of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14 The Best-Laid Schemes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter014#ch14-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15 Fools Rush In")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter015#ch15-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16 Where Angels Fear to Tread")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter016#ch16-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Five: Ancestral Voices Prophesying War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17 Oh, What a Tangled Web!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter017#ch17-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18 Grasp the Nettle")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter018#ch18-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19 Double-Dyed Deceiver")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter019#ch19-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20 They That Take the Sword")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter020#ch20-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21 Auf den Bergen 1st Freiheit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter021#ch21-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Six: Let Slip the Dogs of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22 Mournful Midnight Hours")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter022#ch22-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23 Two’s Company, Three’s a Crowd")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter023#ch23-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24 A House Divided")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter024#ch24-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25 On with the Dance")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter025#ch25-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Seven: The Winds Blew and Beat upon That House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26 Time Ambles Withal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter026#ch26-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27 With Hell at Agreement")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter027#ch27-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28 The Sparks Fly Upward")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter028#ch28-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/part08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Book Eight: The Flinty and Steel Couch of War")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29 Secret Dread and Inward Horror")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter029#ch29-XVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XVII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30 Those in Peril on the Sea")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XIV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter030#ch30-XV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31 Even in the Cannon’s Mouth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter031#ch31-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32 They That Worship the Beast")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-I",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("I")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-II",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("II")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-III",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("III")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-IV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IV")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-V",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("V")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-VIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("VIII")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-IX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("IX")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-X",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("X")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Book3/xhtml/chapter032#ch32-XI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("XI")])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/Preview",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Preview: "), _c('i', [_vm._v("A World to Win")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc2"
  }, [_c('span', {
    attrs: {
      "href": "#/Comon/author",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dc27d5a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bundle_content.vue
// module id = 69
// module chunks = 0